module.exports = __webpack_public_path__ + "img/get_app-24px.d888c28a.svg";